import { render, staticRenderFns } from "./ReadonlyTextarea.vue?vue&type=template&id=0a0184e6&scoped=true"
import script from "./ReadonlyTextarea.vue?vue&type=script&lang=js"
export * from "./ReadonlyTextarea.vue?vue&type=script&lang=js"
import style0 from "./ReadonlyTextarea.vue?vue&type=style&index=0&id=0a0184e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0184e6",
  null
  
)

export default component.exports